// 
// -----------------------------------------------------------------------------
(function ($cMap) {

	if ($cMap.length === 0) {return false;}

	var lat = $cMap.find('.marker').data('lat');
	var long = $cMap.find('.marker').data('long');
	var wrapHeight = $('.contacts-wrap').height();
	var totalHeight = wrapHeight + 400;

	var panPoint = (wrapHeight /2);

	google.maps.event.addDomListener(window, 'load', init);

	function init() {
	    var mapOptions = {
	        zoom: 14,
	        scrollwheel: false,
	        center: new google.maps.LatLng(lat, long), 

	        styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]};

	    var mapElement = document.getElementById('contact-map');


	    var map = new google.maps.Map(mapElement, mapOptions);

	    if (matchMedia) {
	      var mq = window.matchMedia("(min-width: 992px)");
	      mq.addListener(WidthChange);
	      WidthChange(mq);
	    }

	    function WidthChange(mq) {

	      if (mq.matches) {
			$cMap.css({'height' : totalHeight });
		    map.panBy(0, -panPoint);
	      } else {
		    map.panBy(0, 0);
	      }

	    }

	    var marker = new google.maps.Marker({
	        position: new google.maps.LatLng(lat, long),
	        map: map,
	        title: 'Todays PA!',
	        icon: themeurl + 'img/marker.png'
	    });
	}



})($( '#contact-map' ));